export default "__VITE_ASSET__BpGX3ahe__"